module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel15-117f6f345b46f0f6a954752e2766a5a9.jpg";